import { ApiResponse } from './../shared/model';
export class ResponseHandler {
    static processData<U>(data: ApiResponse<U>): U {
        if (data.status.statusCode == 1 || data.status.statusCode == -3)
            return data.response;
        else
            throw new Error(data.status.displayMessage);
    }
}